/**
 * @file 账号用量账单搜索表单mixin
 */
import { mapState } from 'vuex';
import { getCurrentMonthTimestamp } from '@/utils/utils';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      conditionFilter: {
        dateRange: getCurrentMonthTimestamp(), // 账单日期
        billItem: ['all'], // 计费项
        keyword: '', // 关键词,
        email: '',
        channelId: ''
      },
      dataSource: {
        contents: [],
        pageNumber: 1,
        pageSize: 10,
        totalItems: 0
      },
      limitPickerMonthTimestamp: getCurrentMonthTimestamp()[0]
    };
  },
  computed: {
    ...mapState({
      billDictionary: state => state.account.billDictionary, // 计费项字典
      overViewInfo: state => state.account.overViewInfo
    }),
    // 产品项列表
    productOptions() {
      const options = [{
        label: '全部',
        value: 'all'
      }];
      const chargeType = this.overViewInfo.chargeType;
      let billDictionary;
      if (chargeType && chargeType !== 'minutes') {
        billDictionary = this.formatSelectData(1, 2);
      } else {
        billDictionary = this.formatSelectData(7);
      }
      billDictionary.map((product, index) => {
        options.push({
          label: product.name,
          value: index,
          children: [
            { label: '全部', value: 'all' },
            ...product.itemList.map(item => ({
              label: item.name === '并发包月' ? '并发' : item.name,
              value: item.id
            }))
          ]
        });
      });
      return options;
    },
  },
  methods: {
    filterDisabledMonth(date) {
      const firstPickeredMonth = this.limitPickerMonthTimestamp;
      if (!firstPickeredMonth) return false;

      // 限制在 12 个月内，起点为 2024.01，最多选到 2023.02 和 2024.12
      const minMonth = dayjs(firstPickeredMonth).subtract(12, 'month').endOf('month').valueOf() + 1;
      const maxMonth = dayjs(firstPickeredMonth).add(12, 'month').valueOf() - 1;

      return date < minMonth || date > maxMonth;
    },
    onMonthPicker(params) {
      this.limitPickerMonthTimestamp = params.minDate.getTime();
    },
    // 过滤下拉框
    formatSelectData(firstFilterId, secondFilterId) {
      let formatData = [];
      const billDictionary = JSON.parse(JSON.stringify(this.billDictionary));
      formatData = billDictionary.map(product => {
        return product.itemList.filter(item => {
          if (!secondFilterId) {
            return item.id !== firstFilterId;
          }
          return !(item.id === firstFilterId || item.id === secondFilterId);
        });
      });
      formatData.map((item, index) => {
        billDictionary[index].itemList = item;
      });
      return billDictionary;
    },
    getSearchParams(unionId) {
      const { dateRange, keyword, email, channelId } = this.conditionFilter;
      const { pageNumber, pageSize } = this.dataSource;
      const itemIds = this.computeItemId();
      const [startDate, endDate] = dateRange;
      const params = {
        pageNumber,
        pageSize,
        itemIds,
        startDate,
        endDate: dayjs(endDate).endOf('month').valueOf()
      };
      if (channelId) {
        params.channelId = channelId;
      }
      if (unionId) {
        params.unionId = unionId;
      }
      if (keyword) {
        params.keyword = keyword;
      }
      if (email) {
        params.email = email.trim();
      }
      return params;
    },
    computeItemId() {
      const { billItem } = this.conditionFilter;
      const itemIds = [];
      const [productValue, billValue] = billItem;
      if (productValue === 'all') {
        this.billDictionary.map((product) => {
          product.itemList.forEach(item => {
            itemIds.push(item.id);
          });
        });
      } else if (billValue === 'all') {
        const cProduct = this.billDictionary.find((product, index) => (index) === productValue);
        cProduct.itemList.forEach(item => {
          itemIds.push(item.id);
        });
      } else {
        itemIds.push(billValue);
      }
      return itemIds.join(',');
    },
  }
};
